import { createPageApp } from '@/lib/createPageApp'
import StudyInJoyPage from './StudyInJoyPage.vue'

createPageApp(StudyInJoyPage).mount()
